import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  thresholdErrorBox: {
    position: 'relative',
    display: 'flex',
    margin: '0 10px',
    border: '1px solid #f5c2c7',
    borderRadius: 4,
    backgroundColor: '#fff5f5',
    overflow: 'hidden',
  },
  thresholdErrorAccent: {
    width: 4,
    flexShrink: 0,
    backgroundColor: '#d32f2f',
  },
  thresholdErrorContent: {
    flex: 1,
    padding: '12px 16px',
  },
  thresholdErrorTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 4,
  },
  thresholdErrorIcon: {
    fontSize: 18,
    color: '#d32f2f',
  },
  thresholdErrorTitle: {
    color: '#d32f2f',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  thresholdErrorMessage: {
    color: '#d32f2f',
    lineHeight: 1.5,
  },
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: 10,
    marginBottom:20,
    height: 40,
    boxSizing: 'border-box',
    gap: 12,
  },
  buttonBase: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    borderRadius: 4,
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  cancelButton: {
    border: '1px solid #3F51B5',
    color: '#3F51B5',
    boxShadow: 'none',
    backgroundColor: '#fff',
    '&:hover': {
        boxShadow: 'none',
      backgroundColor: '#fff',
    },
  },
  saveButton: {
    color: '#fff',
    boxShadow: 'none',
    backgroundColor: '#3F51B5',
    '&:hover': {
        boxShadow: 'none',
      backgroundColor: '#3F51B5',
    },
  },
  loaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 100,
    height: 40,
  },
  loader: {
    color: '#3F51B5',
  },
}));

export default useStyles;
